import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { covertToTimeDateDigit } from '../../Shared/colorFormat';
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export default function TimelineDoc({ steps, isRTL }: any) {
  const classes = useStyles();
  return (
    <Timeline align={isRTL ? 'left' : 'right'}>
      <Box border={1} borderColor={'#dadada'} borderRadius={10}>
        <Paper
          elevation={0}
          style={{
            borderRadius: 10,
          }}
          className={classes.paper}
        >
          <Timeline align={isRTL ? 'left' : 'right'}>
            {steps?.length > 0 &&
              steps?.map((step: any, i: number) => {
                return (
                  <TimelineItem>
                    <TimelineOppositeContent style={{ maxWidth: 150 }}>
                      <Typography variant="body2" color="textSecondary">
                        {covertToTimeDateDigit(step?.stepTime)}
                      </Typography>
                      <Typography variant="body2">
                        {step?.stepUserName}
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <Box
                        style={{
                          width: 14,
                          height: 14,
                          backgroundColor: `${step?.stepColor}99` || 'gray',
                          borderRadius: 7,
                          marginBottom: 7,
                          marginTop: 7,
                        }}
                      ></Box>
                      {i < steps?.length - 1 && (
                        <TimelineConnector
                          style={{
                            backgroundColor: `${step?.stepColor}99`,
                          }}
                        />
                      )}
                    </TimelineSeparator>
                    <TimelineContent>
                      <Paper
                        elevation={0}
                        style={{
                          borderRadius: 10,
                          backgroundColor: step?.stepColor
                            ? `${step?.stepColor}22`
                            : '#f5f5f5',
                        }}
                        className={classes.paper}
                      >
                        <Typography
                          style={{
                            fontWeight: 'bold',
                            marginBottom: 5,
                          }}
                        >
                          {isRTL ? step?.stepNameAr : step?.stepName}
                        </Typography>
                        <Typography style={{ paddingBottom: 5 }}>
                          {step?.stepDesc}
                        </Typography>
                      </Paper>
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
          </Timeline>
        </Paper>
      </Box>
    </Timeline>
  );
}
